// Profile
import UserProfile from "../pages/Authentication/UserProfile"
// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import HomePage from "../pages/HomePage"

// Common Data Modules Pages
import { settingsRoutes } from "./Settings"
import NotFound from "pages/NotFound"
import { ClaimRoutes } from "./Claim"
import { ReinsurerReportsRoutes } from "./Reports/ReinsurerReportsRoutes"
import { CustomerStakeholdersRoutes } from "./Stakerholders/CustomerStakeholdersRoutes"
import ConfirmMail from "pages/Authentication/ConfirmMail"
import ResetPassword from "pages/Authentication/ResetPassword"
import { isCustomerUser, isReinsurerUser } from "utils"
// Add Company

export const getAuthProtectedRoutes = () => {
  const isCustomer = isCustomerUser()
  const isReinsurer = isReinsurerUser()

  return [
    // settings routes
    ...settingsRoutes,
    // claim routes
    ...(isCustomer ? ClaimRoutes : []),
    // reports routes
    ...(isReinsurer ? ReinsurerReportsRoutes : []),
    // Customer stakeholders routes
    ...(isCustomer ? CustomerStakeholdersRoutes : []),
    { path: "/profile", component: UserProfile },
    { path: "/", exact: true, component: HomePage },
    // 404 Page
    { path: "*", component: NotFound },
  ]
}

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },

  { path: "/forgot-password", component: ForgetPwd },
  { path: "/confirm-mail", component: ConfirmMail },
  { path: "/new-password", component: ResetPassword },
]
export { publicRoutes }
